<button (click)="toggle()" type="button" class="toggle" [class.active]="visible">Pomoč</button>
<div class="container" *ngIf="visible">
  <div class="title">Pomoč</div>
  <button type="button" class="btn-close" (click)="toggle()"></button>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
